<template>
    <div class="flex flex-col items-center justify-center flex-1 h-full p-4">
        <CircleX :size="48" class="text-red-500 dark:text-red-400 mb-4" />
        <p :aria-label="$t('ariaLabel.errorMessage')" class="text-center">
            {{ $t('error.passwordResetTokenExpired') }}
        </p>
        <Button
            as="a"
            :aria-label="$t('ariaLabel.backToLoginButton')"
            class="w-full md:w-auto mt-8"
            href="#login"
            severity="secondary"
            size="small"
            :label="$t('backToLogin')"
            variant="text" />
    </div>
</template>

<script lang="ts">
import { CircleX } from 'lucide-vue-next';

export default {
    components: {
        CircleX
    }
};
</script>
